import { useState } from "react";

/**
 * Image with graceful fallback. When the underlying `<img>` fires an
 * `onError` we swap the broken tile for a subtle Aii Group watermark
 * so participants + partners don't see the browser's default broken
 * icon on activity thumbnails, tour heroes or missing profile pics.
 *
 * Props mirror <img>. `fallbackLabel` overrides the tile text if the
 * caller wants context ("Activity photo unavailable"). Set `hideOnError`
 * to render nothing at all when the source fails.
 */
export default function ImgWithFallback({
  src, alt = "", className = "", fallbackLabel = "Aii Group",
  hideOnError = false, ...rest
}) {
  const [failed, setFailed] = useState(false);
  if (failed && hideOnError) return null;
  if (failed || !src) {
    return (
      <div className={`flex flex-col items-center justify-center bg-[color:var(--aii-green-tint)]/60 text-[color:var(--aii-green-dark)] ${className}`}
           role="img" aria-label={alt || fallbackLabel} data-testid="img-fallback">
        <img src="/aii-logo.png" alt="" className="w-8 h-8 opacity-60"
             onError={(e) => { e.currentTarget.style.display = "none"; }}/>
        <div className="text-[10px] uppercase tracking-widest font-bold mt-1 opacity-70">{fallbackLabel}</div>
      </div>
    );
  }
  return (
    <img src={src} alt={alt} className={className} onError={() => setFailed(true)} {...rest}/>
  );
}
